import { MGDropdownField, MGDropdownItem } from "@/components/inputs";
import { MGSpacing } from "@/components/spacing";
import { MGHelperText } from "@/components/typography";
import { useTranslation } from "react-i18next";

/**
 * Screen previews setting for a class: whether teachers see device screens (grid previews and
 * the live view in the student detail view). Stored as screen_share_enabled ON/OFF.
 * The former "Active Tab" value is gone; use normalizeScreenPreviewsMode() on stored values.
 */
export const ScreenshareModePicker = ({ name, placeholder, onChange, loading, disabled }) => {
  const { t } = useTranslation();

  const onChangeHandlder = (value) => {
    if (typeof onChange === "function") onChange(value);
  };

  return (
    <MGDropdownField
      name={name}
      placeholder={placeholder}
      onChange={onChangeHandlder}
      loading={loading}
      disabled={disabled}
    >
      <MGDropdownItem value="ON">
        {t("On")} <MGSpacing size={"xxs"} />
        <MGHelperText>{t("(Chromebook and Android only)")}</MGHelperText>
      </MGDropdownItem>
      <MGDropdownItem value="OFF">{t("Off")}</MGDropdownItem>
    </MGDropdownField>
  );
};

/**
 * Map a stored or broadcast screen previews value onto the two supported options. Classes saved
 * with the removed "Active Tab" mode (or an older dashboard broadcasting it) count as OFF.
 * Returns undefined for a missing value so callers can apply their own default.
 */
export const normalizeScreenPreviewsMode = (value) => {
  if (value === undefined || value === null || value === "") return undefined;
  return String(value).toUpperCase() === "ON" ? "ON" : "OFF";
};
